/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GeneralCheckResult,
  OrgResearchReport,
} from '../models/index';
import {
    GeneralCheckResultFromJSON,
    GeneralCheckResultToJSON,
    OrgResearchReportFromJSON,
    OrgResearchReportToJSON,
} from '../models/index';

export interface SetInvestigateOpenSourceResultRequest {
    lei: string;
    domain: string;
    orgResearchReport: OrgResearchReport;
}

export interface SetIsFilePresentRequest {
    domain: string;
    generalCheckResult: GeneralCheckResult;
}

export interface SetIsRecordPresentRequest {
    domain: string;
    generalCheckResult: GeneralCheckResult;
}

/**
 * 
 */
export class MocksAPITestControllerApi extends runtime.BaseAPI {

    /**
     * Clean up mocks
     */
    async cleanRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/org/.private/mocks`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Clean up mocks
     */
    async clean(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.cleanRaw(initOverrides);
        return await response.value();
    }

    /**
     * Configure open source investigation results
     */
    async setInvestigateOpenSourceResultRaw(requestParameters: SetInvestigateOpenSourceResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['lei'] == null) {
            throw new runtime.RequiredError(
                'lei',
                'Required parameter "lei" was null or undefined when calling setInvestigateOpenSourceResult().'
            );
        }

        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling setInvestigateOpenSourceResult().'
            );
        }

        if (requestParameters['orgResearchReport'] == null) {
            throw new runtime.RequiredError(
                'orgResearchReport',
                'Required parameter "orgResearchReport" was null or undefined when calling setInvestigateOpenSourceResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/.private/mocks/{lei}/{domain}/open-source-investigation`.replace(`{${"lei"}}`, encodeURIComponent(String(requestParameters['lei']))).replace(`{${"domain"}}`, encodeURIComponent(String(requestParameters['domain']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrgResearchReportToJSON(requestParameters['orgResearchReport']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Configure open source investigation results
     */
    async setInvestigateOpenSourceResult(requestParameters: SetInvestigateOpenSourceResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.setInvestigateOpenSourceResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Configure DNS file investigation result
     */
    async setIsFilePresentRaw(requestParameters: SetIsFilePresentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling setIsFilePresent().'
            );
        }

        if (requestParameters['generalCheckResult'] == null) {
            throw new runtime.RequiredError(
                'generalCheckResult',
                'Required parameter "generalCheckResult" was null or undefined when calling setIsFilePresent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/.private/mocks/{domain}/dns-file-result`.replace(`{${"domain"}}`, encodeURIComponent(String(requestParameters['domain']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GeneralCheckResultToJSON(requestParameters['generalCheckResult']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Configure DNS file investigation result
     */
    async setIsFilePresent(requestParameters: SetIsFilePresentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.setIsFilePresentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Configure DNS text investigation result
     */
    async setIsRecordPresentRaw(requestParameters: SetIsRecordPresentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['domain'] == null) {
            throw new runtime.RequiredError(
                'domain',
                'Required parameter "domain" was null or undefined when calling setIsRecordPresent().'
            );
        }

        if (requestParameters['generalCheckResult'] == null) {
            throw new runtime.RequiredError(
                'generalCheckResult',
                'Required parameter "generalCheckResult" was null or undefined when calling setIsRecordPresent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/org/.private/mocks/{domain}/dns-text-result`.replace(`{${"domain"}}`, encodeURIComponent(String(requestParameters['domain']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GeneralCheckResultToJSON(requestParameters['generalCheckResult']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Configure DNS text investigation result
     */
    async setIsRecordPresent(requestParameters: SetIsRecordPresentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.setIsRecordPresentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
